import React from "react";

const AdvancedPasteModal = ({ gridConfig, setGridConfig, onClose, onApply }) => {
  return (
    <>
      <div className="modal-overlay" onClick={onClose}>
        <div
          className="modal-card"
          role="dialog"
          aria-modal="true"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-title">Advanced Paste</div>

          <div className="modal-inputs">
            <label>
              Rows:
              <input
                type="number"
                min="1"
                value={gridConfig.rows}
                onChange={(e) =>
                  setGridConfig({ ...gridConfig, rows: +e.target.value })
                }
              />
            </label>
            <label>
              Columns:
              <input
                type="number"
                min="1"
                value={gridConfig.cols}
                onChange={(e) =>
                  setGridConfig({ ...gridConfig, cols: +e.target.value })
                }
              />
            </label>
            <label>
              Delta X:
              <input
                type="text"
                value={gridConfig.posX}
                onChange={(e) =>
                  setGridConfig({ ...gridConfig, posX: +e.target.value })
                }
              />
            </label>
            <label>
              Delta Y:
              <input
                type="text"
                value={gridConfig.posY}
                onChange={(e) =>
                  setGridConfig({ ...gridConfig, posY: +e.target.value })
                }
              />
            </label>
            <label>
              Row Spacing:
              <input
                type="text"
                value={gridConfig.rowSpacing}
                onChange={(e) =>
                  setGridConfig({ ...gridConfig, rowSpacing: +e.target.value })
                }
              />
            </label>
            <label>
              Column Spacing:
              <input
                type="number"
                value={gridConfig.colSpacing}
                onChange={(e) =>
                  setGridConfig({ ...gridConfig, colSpacing: +e.target.value })
                }
              />
            </label>
          </div>

          <div className="modal-actions">
            <button className="btn-minimal" onClick={onClose}>
              Cancel
            </button>
            <button className="btn-minimal btn-primary" onClick={onApply}>
              Apply
            </button>
          </div>
        </div>
      </div>

      {/* Inline CSS block */}
      <style>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.4);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }

        .modal-card {
          background: #0e0d0dff;
          border-radius: 8px;
          width: 400px;
          max-width: 90%;
          padding: 20px;
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
          animation: fadeIn 0.2s ease-in-out;
        }

        .modal-title {
          font-size: 1.25rem;
          font-weight: 600;
          margin-bottom: 16px;
          text-align: center;
        }

        .modal-inputs {
          display: grid;
          gap: 10px;
          margin-bottom: 20px;
        }

        .modal-inputs label {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 0.9rem;
        }

        .modal-inputs input {
          width: 100px;
          padding: 4px 6px;
          border: 1px solid #ccc;
          border-radius: 4px;
        }

        .modal-actions {
          display: flex;
          justify-content: flex-end;
          gap: 10px;
        }

        .btn-minimal {
          padding: 6px 12px;
          background: #0c0c0cff;
          border: 1px solid #ccc;
          border-radius: 4px;
          cursor: pointer;
          font-size: 0.9rem;
        }

        .btn-minimal:hover {
          background: #0c0c0cff;
        }

        .btn-primary {
          background: #007bff;
          color: white;
          border-color: #007bff;
        }

        .btn-primary:hover {
          background: #0056b3;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </>
  );
};

export default AdvancedPasteModal;
